/**
 * Learn more about typography customization
 * https://material-ui.com/customization/typography/
 *
 * Default theme typography values provided by MUI
 * https://material-ui.com/customization/default-theme/?expand-path=$.typography
 */

export default {
	fontSize: 16,
	h1: { fontSize: '2.5rem', fontWeight: 500 },
	h2: { fontSize: '2rem' },
	h3: { fontSize: '1.5rem' },
	h4: { fontSize: '1.25rem' },
	h5: { fontSize: '1.125rem' },
	h6: { fontSize: '1rem' },
	subtitle1: { fontSize: '0.875rem' },
	subtitle2: { fontSize: '0.8125rem' },
	subtitle3: { fontSize: '0.3125rem' },
	fontFamily: [
		'DINNextRoundedLTPro',
		'-apple-system',
		'BlinkMacSystemFont',
		'"Segoe UI"',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Cantarell',
		'"Fira Sans"',
		'"Droid Sans"',
		'"Helvetica Neue"',
		'sans-serif',
	].join(','),
};
